import overshirt1 from '@/assets/military-overshirt-1.jpg.asset.json';
import overshirt2 from '@/assets/military-overshirt-2.jpg.asset.json';
import overshirt3 from '@/assets/military-overshirt-4.jpg.asset.json';
import balletHoodie1 from '@/assets/ballet-hoodie-1b.jpg.asset.json';
import balletHoodie2 from '@/assets/ballet-hoodie-2.jpg.asset.json';
import balletHoodie3 from '@/assets/ballet-hoodie-3.jpg.asset.json';
import paintBlazer1 from '@/assets/paint-blazer-1.jpg.asset.json';
import paintBlazer2 from '@/assets/paint-blazer-2.jpg.asset.json';
import paintBlazer3 from '@/assets/paint-blazer-3.jpg.asset.json';
import bluePalace1 from '@/assets/blue-palace-sweatshirt-1.jpg.asset.json';
import bluePalace2 from '@/assets/blue-palace-sweatshirt-2.jpg.asset.json';
import bluePalace3 from '@/assets/blue-palace-sweatshirt-3.jpg.asset.json';
import greyChoreJacket1 from '@/assets/grey-chore-jacket-1.jpg.asset.json';
import greyChoreJacket2 from '@/assets/grey-chore-jacket-2.jpg.asset.json';
import greyChoreJacket3 from '@/assets/grey-chore-jacket-3.jpg.asset.json';
import greyChoreJacket4 from '@/assets/grey-chore-jacket-4.jpg.asset.json';
import galleryImage1 from '@/assets/gallery-image-1.jpg';
import galleryImage2 from '@/assets/gallery-image-2.jpg';
import slot1Image1 from '@/assets/slot1-image1.jpg';
import slot1Image2 from '@/assets/slot1-image2.jpg';
import slot2Image1 from '@/assets/slot2-image1.jpg';
import slot2Image2 from '@/assets/slot2-image2.jpg';
import slot2Ring from '@/assets/slot2-ring.jpg';
import slot3Ring from '@/assets/slot3-ring.jpg';
import slot6Ring from '@/assets/slot6-ring.jpg';
import nylonHvmWorkerJacket1 from '@/assets/nylon-hvm-worker-jacket-1.jpg.asset.json';
import nylonHvmWorkerJacket2 from '@/assets/nylon-hvm-worker-jacket-2.jpg.asset.json';

export interface Product {
  slug: string;
  name: string;
  priceSek: number;
  images: { src: string; alt: string; scale?: number }[];
  description: string;
  details: string[];
  sizes: string[];
  scale?: number;
  /** Which department the product belongs to. */
  department: 'instock' | 'coming';
}

/** SEK -> EUR conversion rate used for dual pricing. */
export const SEK_TO_EUR = 0.088;

export const formatPrice = (priceSek: number) =>
  `${priceSek} SEK / ${Math.round(priceSek * SEK_TO_EUR)} EUR`;

export const products: Product[] = [
  {
    slug: 'distressed-military-overshirt',
    name: 'Distressed Military Overshirt',
    priceSek: 1800,
    images: [
      { src: overshirt2.url, alt: 'Distressed Military Overshirt front', scale: 1.09 },
      { src: overshirt1.url, alt: 'Distressed Military Overshirt worn' },
      { src: overshirt3.url, alt: 'Distressed Military Overshirt sleeve detail' },
    ],
    description:
      'Reworked vintage military overshirt in faded olive cotton sateen. Frayed collar and placket, chest flap pockets and a boxy, slightly cropped cut. One of a kind — wear marks and fading are part of the piece. Model is 181cm / 73kg.',
    details: ['Reworked vintage military shirt', 'Faded olive cotton', 'Frayed collar and placket', 'Boxy cropped fit', 'One of a kind'],
    sizes: ['M'],
    scale: 1.0,
    department: 'instock',
  },
  {
    slug: 'palace-theatre-distressed-sweatshirt-blue',
    name: 'Palace Theatre Distressed Sweatshirt',
    priceSek: 1800,
    images: [
      { src: bluePalace1.url, alt: 'Palace Theatre Distressed Sweatshirt in washed blue', scale: 1.09 },
      { src: bluePalace2.url, alt: 'Palace Theatre Distressed Sweatshirt paint and fabric detail' },
      { src: bluePalace3.url, alt: 'Palace Theatre Distressed Sweatshirt back detail' },
    ],
    description:
      'Heavyweight sweatshirt in washed dusty blue cotton fleece with hand-distressed collar, hem and cuffs. Faded Palace Theatre archive print with ballet illustration across the chest, finished with hand-applied paint marks. One of a kind. Model is 181cm / 73kg.',
    details: ['Heavyweight cotton fleece', 'Washed dusty blue', 'Hand-distressed edges', 'Archive print with paint marks', 'One of a kind'],
    sizes: ['M'],
    scale: 1.0,
    department: 'instock',
  },
  {
    slug: 'palace-theatre-distressed-hoodie',
    name: 'Palace Theatre Distressed Hoodie',
    priceSek: 1500,
    images: [
      { src: balletHoodie2.url, alt: 'Palace Theatre Distressed Hoodie front', scale: 0.8 },
      { src: balletHoodie1.url, alt: 'Palace Theatre Distressed Hoodie worn' },
      { src: balletHoodie3.url, alt: 'Palace Theatre Distressed Hoodie detail' },
    ],
    description:
      'Heavyweight grey marl hoodie with hand-distressed hood, seams and cuffs. Faded Palace Theatre archive print with ballet illustration across the chest, finished with paint marks. One of a kind. Model is 181cm / 73kg.',
    details: ['Heavyweight cotton fleece', 'Hand-distressed finish', 'Archive print with paint marks', 'Boxy fit', 'One of a kind'],
    sizes: ['L'],
    scale: 1.0,
    department: 'instock',
  },
  {
    slug: 'washed-grey-chore-jacket',
    name: 'Washed Grey Chore Jacket',
    priceSek: 2000,
    images: [
      { src: greyChoreJacket1.url, alt: 'Washed Grey Chore Jacket front', scale: 0.95 },
      { src: greyChoreJacket2.url, alt: 'Washed Grey Chore Jacket worn' },
      { src: greyChoreJacket3.url, alt: 'Washed Grey Chore Jacket back detail' },
      { src: greyChoreJacket4.url, alt: 'Washed Grey Chore Jacket alternate front' },
    ],
    description:
      'Washed grey cotton chore jacket with a soft-collapse collar, button front and multiple pockets. Distressed edges and a faded, lived-in surface. Model is 181cm / 73kg.',
    details: ['Washed grey cotton', 'Button front', 'Multiple pockets', 'Distressed edges', 'One of a kind'],
    sizes: ['S'],
    scale: 1.0,
    department: 'instock',
  },
  {
    slug: 'paint-splattered-blazer',
    name: 'Paint Splattered Blazer',
    priceSek: 1400,
    images: [
      { src: paintBlazer2.url, alt: 'Paint Splattered Blazer front', scale: 0.98 },
      { src: paintBlazer1.url, alt: 'Paint Splattered Blazer worn' },
      { src: paintBlazer3.url, alt: 'Paint Splattered Blazer detail' },
    ],
    description:
      'Reworked washed-black cotton blazer with hand-applied paint marks and distressed edges along the lapel, pockets and cuffs. Two-button front with patch pockets and a soft, unstructured shoulder. One of a kind. Model is 181cm / 73kg.',
    details: ['Reworked washed-black cotton', 'Hand-applied paint marks', 'Distressed edges', 'Unstructured shoulder', 'One of a kind'],
    sizes: ['M'],
    scale: 1.0,
    department: 'instock',
  },
  {
    slug: 'heaven-made-jacket',
    name: 'Heaven Made Jacket',
    priceSek: 2400,
    images: [
      { src: slot1Image1, alt: 'Heaven Made Jacket front' },
      { src: slot1Image2, alt: 'Heaven Made Jacket back' },
    ],
    description:
      'Hand-finished outerwear piece in a heavyweight cotton blend. Boxy fit with a lived-in surface and hand-applied Heaven Made artwork on the back.',
    details: ['Heavyweight cotton blend', 'Hand-applied artwork', 'Boxy fit', 'Made in limited quantity'],
    sizes: ['S', 'M', 'L', 'XL'],
    department: 'coming',
  },
  {
    slug: 'heaven-made-zip-hoodie',
    name: 'Heaven Made Zip Hoodie',
    priceSek: 1800,
    images: [
      { src: galleryImage1, alt: 'Heaven Made Zip Hoodie' },
      { src: galleryImage2, alt: 'Heaven Made Zip Hoodie detail' },
    ],
    description:
      'Full-zip hoodie with a metal hardware detail and a washed finish. Layers cleanly under outerwear.',
    details: ['Cotton fleece', 'Metal zip hardware', 'Washed finish'],
    sizes: ['S', 'M', 'L', 'XL'],
    department: 'coming',
  },
  {
    slug: 'heaven-made-graphic-tee',
    name: 'Heaven Made Graphic Tee',
    priceSek: 1200,
    images: [
      { src: slot2Image1, alt: 'Heaven Made Graphic Tee front' },
      { src: slot2Image2, alt: 'Heaven Made Graphic Tee back' },
    ],
    description:
      'Brushed cotton crewneck with a relaxed shoulder and print worked directly into the fabric. Softens with every wash.',
    details: ['100% brushed cotton', 'Relaxed fit', 'Ribbed collar and cuffs'],
    sizes: ['S', 'M', 'L', 'XL'],
    department: 'coming',
  },
  {
    slug: 'nylon-hvm-worker-jacket',
    name: 'Nylon HVM Worker Jacket',
    priceSek: 1600,
    images: [
      { src: nylonHvmWorkerJacket1.url, alt: 'Nylon HVM Worker Jacket front' },
      { src: nylonHvmWorkerJacket2.url, alt: 'Nylon HVM Worker Jacket back' },
    ],
    description:
      'Lightweight nylon worker jacket with a structured collar, button front and chest patch pocket. Washed finish with a subtle sheen, cut boxy for easy layering. Made in limited quantity.',
    details: ['Lightweight nylon', 'Button front', 'Chest patch pocket', 'Boxy fit', 'Made in limited quantity'],
    sizes: ['S', 'M', 'L', 'XL'],
    department: 'coming',
  },
  {
    slug: 'heaven-made-ring-i',
    name: 'Heaven Made Ring I',
    priceSek: 900,
    images: [{ src: slot3Ring, alt: 'Heaven Made Ring I' }],
    description: 'Cast sterling silver ring with a hand-filed, uneven surface. Each piece is one of a kind.',
    details: ['925 silver', 'Sterling silver', 'Hand-finished', 'One of a kind'],
    sizes: ['S', 'M', 'L'],
    department: 'coming',
  },
  {
    slug: 'heaven-made-ring-ii',
    name: 'Heaven Made Ring II',
    priceSek: 950,
    images: [{ src: slot6Ring, alt: 'Heaven Made Ring II' }],
    description: 'Wide-band silver ring with a raw, molten edge finished by hand in the studio.',
    details: ['925 silver', 'Sterling silver', 'Wide band', 'Hand-finished'],
    sizes: ['S', 'M', 'L'],
    department: 'coming',
  },
  {
    slug: 'heaven-made-ring-iii',
    name: 'Heaven Made Ring III',
    priceSek: 850,
    images: [{ src: slot2Ring, alt: 'Heaven Made Ring III' }],
    description: 'Slim silver band with a textured surface, made to be worn stacked or alone.',
    details: ['925 silver', 'Sterling silver', 'Slim band', 'Textured surface'],
    sizes: ['S', 'M', 'L'],
    department: 'coming',
  },
];

export const getProductsByDepartment = (department: Product['department']) =>
  products.filter((p) => p.department === department);

export const getProduct = (slug?: string) => products.find((p) => p.slug === slug);
